import React, {Component} from 'react';
import FilterBySalary from 'components/organisms/filter-by-salary';
import FilterByPoints from 'components/organisms/filter-by-points';
import ExposureMode from 'components/molecules/exposure-mode';
import UniquePlayersQuantity from 'components/molecules/unique-players-quantity';
import LineupsQuantity from 'components/organisms/lineups-quantity';
import SelectSalaryCap from 'components/organisms/select-salary-cap';
import OptimizeButton from 'components/molecules/optimize-button';
import RangeOfOutcomes from 'components/organisms/range-of-outcomes/range-of-outcomes';
import {connect} from 'react-redux';
import RandomTeamStacking from 'components/organisms/random-team-stacking';
import PrioritizeCompletingLineupsAboveExp from 'components/molecules/prioritize-completing-lineups-above-exp';
import AllowOpposingTeamsInLineup from 'components/molecules/allow-opposing-teams-in-lineup';
import UserPointsType from 'components/molecules/user-points-type';
import ShowPlayersExposureWhileOptimized from 'components/molecules/show-players-exposure-while-optimized';
import PlayerCombinationStacking from 'components/organisms/player-combination-stacking';
import OptimizeOpener from 'components/molecules/optimize-opener';
import PlayerGroupingsSwitch from 'components/molecules/player-groupings-switch';

class PlayersDashboardComponent extends Component {
    render() {
        const {playersFilter} = this.props;

        return (
            <div>
                <div className="filters-table">
                    <OptimizeOpener />
                    <div className="filters-top">
                        <div className="filters-top-holder">
                            <FilterBySalary
                                key={`sr-${playersFilter.playersType}`}
                                useDragging={true}
                                mode={playersFilter.playersType}
                            />
                            <FilterByPoints
                                key={`pr-${playersFilter.playersType}`}
                                useDragging={true}
                                mode={playersFilter.playersType}
                            />
                            <SelectSalaryCap useDragging={true} />
                            <LineupsQuantity useDragging={true} />
                        </div>
                        <div className="filters-cell select-cell">
                            <ExposureMode />
                            <UserPointsType
                                options={{
                                    points: 'Fpts/Win Projection',
                                    adminPoints: 'Projection',
                                }}
                                tooltip={
                                    'Select from standard "Projections" or projections based on the assumption that the players on each of the teams win their games.'
                                }
                            />
                            <UniquePlayersQuantity />
                        </div>
                    </div>
                    <div className="filters-bottom">
                        <div className="filters-cell">
                            <AllowOpposingTeamsInLineup />
                        </div>
                        <div className="filters-cell">
                            <PrioritizeCompletingLineupsAboveExp />
                        </div>
                        <div className="filters-cell">
                            <RangeOfOutcomes useDragging={true} config={{sport: 'lol'}} />
                        </div>
                        <div className="filters-cell">
                            <ShowPlayersExposureWhileOptimized />
                        </div>
                    </div>
                    <OptimizeButton />
                </div>
                <RandomTeamStacking />
                <PlayerGroupingsSwitch>
                    <PlayerCombinationStacking />
                </PlayerGroupingsSwitch>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {filters: playersFilter} = state.playersData;

    return {
        playersFilter,
    };
}

let PlayersDashboard = connect(mapStatesToProps)(PlayersDashboardComponent);

export {PlayersDashboard};
